import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n' // load vuex i18n module
import app from '@/store/modules/app';
import user from '@/store/modules/user';
import reports from '@/store/modules/reports';
import watched from '@/store/modules/watched-lists';
import imageAnalyst from '@/store/modules/image-analyst'
import processRunner from '@/store/modules/process-runners'
import * as getters from '@/store/getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,
  getters,
  modules: {
    app,
    user,
    reports,
    imageAnalyst,
    processRunner,
    watched
  },
  plugins: [],
  state: {},
  mutations: {},
})

Vue.use(VuexI18n.plugin, store)

export default store
